import { render, staticRenderFns } from "./OrderAddCard.vue?vue&type=template&id=55575d4b&"
import script from "./OrderAddCard.vue?vue&type=script&lang=js&"
export * from "./OrderAddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports